// input: JSON.stringified object as a string
// output: returns a JSON object with trimmed key, values
export var trimObjectKeyValues = function trimObjectKeyValues(obj) {
  /*
    if there were quotes within the object, eg: {" key ": ' and "let" it '},
    Stringify will escape them, but the regex will strip whitespace around those as well, producing 'and "let"it'.
    As JS doesn't have negative lookbehinds, you can solve this with said function
    */

  try {
    return JSON.parse(obj.replace(/(\\)?"\s*|\s+"/g, function ($0, $1) {
      return $1 ? $0 : '"';
    }));
  } catch (e) {
    return JSON.parse('{}');
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/utils/TrimObjects.js
// module id = 4520
// module chunks = 11